import { call, put } from 'redux-saga/effects';

import { setUserSubscription } from '../actions/accountSettingsAction';
import {
  setCancelSubscriptionMessage,
  setCancelSubscriptionSuccess,
  setCancelSubscriptionWaiting,
  setRefundAmountMessage,
  setRevertCancellationMessage,
  setRevertCancellationSuccess,
  setRevertCancellationWaiting,
  setSubscriptionActivationMessage,
  setSubscriptionActivationSuccess,
  setSubscriptionActivationWaiting,
  setSubscriptionOperationMessage,
  setSubscriptionOperationSuccess,
  setSubscriptionOperationWaiting,
  setUpdateSubscriptionPlanMessage,
  setUpdateSubscriptionPlanSuccess,
  setUpdateSubscriptionPlanWaiting,
} from '../actions/manageSubscriptionActions';
import Services from '../services/index';
import { removeLocalStorageItem } from '../utils/localStorage';

export function* cancelSubscriptionSaga(action) {
  try {
    yield put(setCancelSubscriptionWaiting(true));

    yield call(
      Services.ManageSubscriptionService.cancelUserSubscription,
      action.subscriptionId,
      action.message,
    );

    yield put(
      setCancelSubscriptionMessage({
        type: 'success',
        text: 'Subscription cancelled!',
      }),
    );

    const response = yield call(
      Services.AccountSettingsService.loadUserSubscription,
      false,
    );
    yield put(setUserSubscription(response));

    yield put(setCancelSubscriptionWaiting(false));
    yield put(setCancelSubscriptionSuccess(true));
  } catch (err) {
    yield put(setCancelSubscriptionWaiting(false));
    yield put(setCancelSubscriptionSuccess(false));
    yield put(
      setCancelSubscriptionMessage({
        type: 'error',
        text: 'Oops! something happend trying to cancel your subscription',
      }),
    );
  }
}

export function* revertCancellationSaga(action) {
  try {
    yield put(setRevertCancellationWaiting(true));

    yield call(
      Services.ManageSubscriptionService.revertCancellation,
      action.subscriptionId,
    );

    yield put(
      setRevertCancellationMessage({
        type: 'success',
        text: 'Cancellation reverted!',
      }),
    );

    const response = yield call(
      Services.AccountSettingsService.loadUserSubscription,
      false,
    );
    yield put(setUserSubscription(response));

    yield put(setRevertCancellationWaiting(false));
    yield put(setRevertCancellationSuccess(true));
  } catch (err) {
    yield put(setRevertCancellationWaiting(false));
    yield put(setRevertCancellationSuccess(false));
    yield put(
      setRevertCancellationMessage({
        type: 'error',
        text: 'The plan you are trying to use does not exist or is no longer available',
      }),
    );
  }
}

export function* switchSubscriptionToStripeSaga(action) {
  try {
    yield put(setSubscriptionOperationWaiting(true));

    const response = yield call(
      Services.ManageSubscriptionService.switchSubscriptionToStripe,
      action.switchSubscription,
    );
    const resp = yield call(
      Services.AccountSettingsService.loadUserSubscription,
      false,
    );
    yield put(setUserSubscription(resp));
    yield put(setSubscriptionOperationWaiting(false));
    yield put(setSubscriptionOperationSuccess(true));
    yield put(
      setSubscriptionOperationMessage({
        type: 'success',
        text: 'Subscription created successfully!',
      }),
    );
  } catch (err) {
    yield put(setSubscriptionOperationWaiting(false));
    yield put(setSubscriptionOperationSuccess(false));
    yield put(
      setSubscriptionOperationMessage({
        type: 'error',
        text: err.response.data,
      }),
    );
  }
}

export function* cancelScheduleOnSwitchIosToStripeSaga() {
  try {
    yield put(setSubscriptionOperationWaiting(true));
    yield call(
      Services.ManageSubscriptionService.cancelScheduleOnSwitchIosToStripe,
    );
    const resp = yield call(
      Services.AccountSettingsService.loadUserSubscription,
      false,
    );
    yield put(setUserSubscription(resp));
    yield put(setSubscriptionOperationWaiting(false));
    yield put(setSubscriptionOperationSuccess(true));
    yield put(
      setSubscriptionOperationMessage({
        type: 'success',
        text: 'Scheduled subscription cancelled',
      }),
    );
  } catch (err) {
    yield put(setSubscriptionOperationWaiting(false));
    yield put(setSubscriptionOperationSuccess(false));
    yield put(
      setSubscriptionOperationMessage({
        type: 'error',
        text: err.response.data,
      }),
    );
  }
}

export function* renewSubscriptionSaga(action) {
  try {
    yield put(setSubscriptionOperationWaiting(true));

    yield call(
      Services.ManageSubscriptionService.renewSubscription,
      action.newSubscription,
    );

    yield call(Services.UserService.getLoggedStudent);

    removeLocalStorageItem('top-notification-closed');

    const response = yield call(
      Services.AccountSettingsService.loadUserSubscription,
      false,
    );
    yield put(setUserSubscription(response));

    yield put(setSubscriptionOperationWaiting(false));
    yield put(setSubscriptionOperationSuccess(true));
    yield put(
      setSubscriptionOperationMessage({
        type: 'success',
        text: 'Subscription renewed Successfully!',
      }),
    );
  } catch (err) {
    yield put(setSubscriptionOperationWaiting(false));
    yield put(setSubscriptionOperationSuccess(false));

    let message =
      'The payment has failed. Please try again later or contact support';
    if (err.response && err.response.data) {
      message = err.response.data;
    }
    yield put(
      setSubscriptionOperationMessage({
        type: 'error',
        text: message,
      }),
    );
  }
}

export function* changeSubscriptionSaga(action) {
  try {
    yield put(setSubscriptionOperationWaiting(true));

    yield call(
      Services.ManageSubscriptionService.changePlan,
      action.id,
      action.subscription,
    );

    yield put(setSubscriptionOperationWaiting(false));
    yield put(setSubscriptionOperationSuccess(true));
    yield put(
      setSubscriptionOperationMessage({
        type: 'success',
        text: 'Subscription changed Successfully!',
      }),
    );
  } catch (err) {
    yield put(setSubscriptionOperationWaiting(false));
    yield put(setSubscriptionOperationSuccess(false));
    yield put(
      setSubscriptionOperationMessage({
        type: 'error',
        text: err.response.data,
      }),
    );
  }
}

export function* upgradeubscriptionSaga(action) {
  try {
    yield put(setSubscriptionOperationWaiting(true));

    const newSubscription = action.newSubscription;

    yield call(
      Services.ManageSubscriptionService.upgradeAccount,
      newSubscription.dutyState,
      newSubscription.rank,
      newSubscription.rate,
      newSubscription.stripeToken,
      newSubscription.tax,
      newSubscription.planId,
    );

    yield call(Services.UserService.getLoggedStudent);

    removeLocalStorageItem('top-notification-closed');
    yield put(setSubscriptionOperationSuccess(true));
    yield put(setSubscriptionOperationWaiting(false));
    yield put(
      setSubscriptionOperationMessage({
        type: 'success',
        text: 'Account upgraded Successfully!',
      }),
    );
  } catch (err) {
    yield put(setSubscriptionOperationWaiting(false));
    yield put(setSubscriptionOperationSuccess(false));
    yield put(
      setSubscriptionOperationMessage({
        type: 'error',
        text: err.response.data,
      }),
    );
  }
}

export function* activateSubscriptionSagas() {
  try {
    yield put(setSubscriptionActivationWaiting(true));
    yield put(setSubscriptionActivationSuccess(false));
    yield call(Services.ManageSubscriptionService.activateSubscription);
    yield put(setSubscriptionActivationSuccess(true));
    yield put(setSubscriptionActivationWaiting(false));
    yield put(
      setSubscriptionActivationMessage({
        type: 'success',
        text: 'Account Activated Successfully!',
      }),
    );
    const response = yield call(
      Services.AccountSettingsService.loadUserSubscription,
      false,
    );
    yield put(setUserSubscription(response));
  } catch (err) {
    yield put(setSubscriptionActivationWaiting(false));
    yield put(setSubscriptionActivationSuccess(false));
    yield put(
      setSubscriptionActivationMessage({
        type: 'error',
        text: 'There was an error trying to activate your subscription. Try again later or contact the support',
      }),
    );
  }
}

export function* updateSubscriptionPlanSagas(action) {
  try {
    yield put(setUpdateSubscriptionPlanWaiting(true));
    yield put(setUpdateSubscriptionPlanSuccess(false));
    const res = yield call(
      Services.ManageSubscriptionService.updateSubscriptionPlan,
      action.planId,
    );
    yield put(setUpdateSubscriptionPlanSuccess(true));
    yield put(setUpdateSubscriptionPlanWaiting(false));
    yield put(
      setUpdateSubscriptionPlanMessage({
        type: 'success',
        text: 'Subscription Plan Updated Successfully!',
      }),
    );
    if (res && res.type && res.type === 'refundAmount') {
      yield put(
        setRefundAmountMessage({
          type: 'success',
          text: `We wanted to let you know that you have received a refund of $${res.refundAmount} for the unused time on your plan. You can expect to see this refund appear on your account within the next 4-5 business days.`,
        }),
      );
    }
    const response = yield call(
      Services.AccountSettingsService.loadUserSubscription,
      false,
    );
    yield put(setUserSubscription(response));
  } catch (err) {
    yield put(setUpdateSubscriptionPlanWaiting(false));
    yield put(setUpdateSubscriptionPlanSuccess(false));

    let message =
      'There was an error trying to update your subscription. Try again later or contact the support.';
    // Stripe errors can reach the client as objects, only messages are shown
    if (err.response && typeof err.response.data === 'string') {
      message = err.response.data;
    }
    yield put(
      setUpdateSubscriptionPlanMessage({
        type: 'error',
        text: message,
      }),
    );
  }
}
